import PropTypes from 'prop-types';
import React from 'react';
import i18n from 'i18next';
import { Modal, Button, Form, Input, Tag, message } from 'antd';
import { apis } from '../api';
import { formatDate } from '../utils';
const { TextArea } = Input;
const { CheckableTag } = Tag;

class Refuse extends React.Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    form: PropTypes.object,
    reportInfo: PropTypes.object,
    history: PropTypes.object,
    changeMenuTaskData: PropTypes.func,
  };

  state = {
    confirmLoading: false,
    status: 0,
    reasonList: [],
    selectedTags: [],
    selectedNames: [],
  };
  componentDidUpdate(prevProps) {
    const { visible } = this.props;
    if (prevProps.visible !== visible && visible) {
      this.setState({ reportInfo: this.props.reportInfo });
      this.props.form.resetFields();
      this.refuseReportReason();
    }
  }

  refuseReportReason = () => {
    apis.ctRefuseReportReason().then(res => {
      if (res.code === '0') {
        this.setState({ reasonList: res.data || [] });
      } else if (res.code === '1009') this.props.history.push('/login');
    });
  };

  handleOk = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const time = formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss');
        this.props.changeMenuTaskData(time);
        //保存评价内容
        const { reportInfo } = this.state;
        const post = { diagId: reportInfo.diagId, description: values.refuse };
        apis.ctRefuseReport(post).then(res => {
          if (res.code === '0') {
            message.success('操作成功');
            this.handleCancel();
            this.props.history.go(-1);
          } else if (res.code === '1009') this.props.history.push('/login');
        });
      }
    });
  };

  //点击“取消按钮”隐藏对话框
  handleCancel = () => {
    this.props.onCancel(false);
  };

  handleChange = (code, name, checked) => {
    const { selectedTags, selectedNames } = this.state;
    const nextSelectedTags = checked
      ? [...selectedTags, code]
      : selectedTags.filter(t => t !== code);
    const nextSelectedNames = checked
      ? [...selectedNames, name]
      : selectedNames.filter(t => t !== name);
    this.props.form.setFieldsValue({ refuse: nextSelectedNames.join(',') });
    this.setState({
      selectedTags: nextSelectedTags,
      selectedNames: nextSelectedNames,
    });
  };

  render() {
    const { confirmLoading, reasonList, selectedTags } = this.state;
    const { selectedNames, reportInfo, reasonMessage } = this.state;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = { labelCol: { span: 3 }, wrapperCol: { span: 21 } };

    if (!reportInfo) return null;
    let initValue = '';
    if (reportInfo.state === 12) initValue = reasonMessage;
    else initValue = selectedNames.join(',');

    let buttons = [
      <Button
        key="cancel"
        onClick={this.handleCancel}
        type="default"
        className="btn-cancel"
      >
        {i18n.t('cancel')}
      </Button>,
    ];
    if (!(reportInfo.state === 12)) {
      buttons.push(
        <Button
          key="submit"
          type="danger"
          loading={confirmLoading}
          onClick={this.handleOk}
          className="btn-ok"
        >
          拒绝报告
        </Button>
      );
    }

    return (
      <Modal
        title="拒绝报告"
        visible={this.props.visible}
        width={800}
        height={500}
        className="group-manager refuse"
        onCancel={this.handleCancel}
        centered={true}
        keyboard={false}
        maskClosable={false}
        footer={buttons}
      >
        <div className="report-modal-alert-content report-modal-refuse">
          <Form {...formItemLayout}>
            <Form.Item label="拒绝原因" colon={false}>
              {getFieldDecorator('refuse', {
                rules: [{ required: true, message: '请选择或填写拒绝原因' }],
                initialValue: initValue,
              })(<TextArea rows={4} disabled={reportInfo.state === 12} />)}
            </Form.Item>
            {reportInfo.state !== 12 && (
              <Form.Item label=" " colon={false} className="refuse-tag">
                {getFieldDecorator('reasons', {})(
                  <div>
                    {reasonList.map((item, index) => (
                      <CheckableTag
                        key={index}
                        checked={selectedTags.indexOf(item.code) > -1}
                        onChange={checked =>
                          this.handleChange(item.code, item.name, checked)
                        }
                      >
                        {item.name}
                      </CheckableTag>
                    ))}
                  </div>
                )}
              </Form.Item>
            )}
          </Form>
        </div>
      </Modal>
    );
  }
}

export default Form.create()(Refuse);
